import React, { useCallback, useEffect } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import card from '../../assets/card.png';
import faceDetection from '../../assets/faceDetection.png';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import { ChooseContainer } from './styles';

const Choose: React.FC = () => {
  const {
    handleChangeCurrentStep,
    handleChangeCurrentValidation,
    handleReturnCurrentStep,
  } = useSteps();

  const { canSelectServices } = useAuth();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.choose);

  const handleSetCNHValidation = useCallback(() => {
    handleChangeCurrentValidation('CNH');
    handleChangeCurrentStep();
  }, [handleChangeCurrentValidation, handleChangeCurrentStep]);

  const handleSetFotoValidation = useCallback(() => {
    handleChangeCurrentValidation('Foto');
    handleChangeCurrentStep();
  }, [handleChangeCurrentValidation, handleChangeCurrentStep]);

  useEffect(() => {
    handleChangeCurrentValidation('');
  }, [handleChangeCurrentValidation]);

  return (
    <Content>
      {canSelectServices && (
        <GoBack onClick={handleReturnCurrentStep}>
          <FaArrowLeft size={16} />
          {tp('back')}
        </GoBack>
      )}
      <Title>{tp('title')}</Title>
      <ChooseContainer>
        <button onClick={handleSetCNHValidation} type="button">
          <img src={card} alt="" /> {tp('cnhOption')}
        </button>
        <button onClick={handleSetFotoValidation} type="button">
          <img src={faceDetection} alt="" /> {tp('faceOption')}
        </button>
      </ChooseContainer>
    </Content>
  );
};

export default Choose;
